import { FormattedMessage } from 'react-intl';
import { useExperiments } from '@alltrails/experiments';
import advancedMapLayersSrc from './feature-thumb-advanced-map-layers.avif';
import customRoutesSrc from './feature-thumb-custom-routes.avif';
import memberDealsSrc from './feature-thumb-member-deals.avif';
import multiDayTripPlanningSrc from './feature-thumb-multi-day.avif';
import offlineMapsSrc from './feature-thumb-offline-maps.avif';
import routeAssistantSrc from './feature-thumb-route-assistant.avif';
import trailConditionsSrc from './feature-thumb-trail-conditions.avif';
import MembershipIncludes from './MembershipIncludes';

const memberDealsRow = {
  body: <FormattedMessage defaultMessage="Exclusive savings on apparel, outdoor accommodations, flights, and more" />,
  src: memberDealsSrc,
  title: <FormattedMessage defaultMessage="Member Deals" />
};

const trailConditionsRow = {
  body: <FormattedMessage defaultMessage="Plan for trail-specific weather, snow depth, and more" />,
  src: trailConditionsSrc,
  title: <FormattedMessage defaultMessage="Trail Conditions" />
};

const rows = (isNigelEnabled: boolean, isInUs: boolean) => [
  isNigelEnabled
    ? {
        body: <FormattedMessage defaultMessage="Plan backpacking trips effortlessly with our built-in assistant" />,
        src: routeAssistantSrc,
        title: <FormattedMessage defaultMessage="Route Assistant" />
      }
    : {
        body: <FormattedMessage defaultMessage="Start from scratch or customize to create your perfect adventure in the app" />,
        src: customRoutesSrc,
        title: <FormattedMessage defaultMessage="Custom Routes" />
      },
  {
    body: <FormattedMessage defaultMessage="Understand the land and terrain before you head out" />,
    src: advancedMapLayersSrc,
    title: <FormattedMessage defaultMessage="Advanced Map Layers" />
  },
  isNigelEnabled
    ? {
        body: <FormattedMessage defaultMessage="Start from scratch or customize to create your perfect adventure in the app" />,
        src: customRoutesSrc,
        title: <FormattedMessage defaultMessage="Custom Routes" />
      }
    : {
        body: <FormattedMessage defaultMessage="Build multi-day trips on the go in the app or on desktop" />,
        src: multiDayTripPlanningSrc,
        title: <FormattedMessage defaultMessage="Multi-Day Trip Planning" />
      },
  {
    body: <FormattedMessage defaultMessage="Download maps so you always know where you are, even without cell service" />,
    src: offlineMapsSrc,
    title: <FormattedMessage defaultMessage="Offline Maps" />
  },
  isInUs ? memberDealsRow : trailConditionsRow
];

type Props = {
  isInUs: boolean;
};

export default function PeakMembershipIncludes({ isInUs }: Props) {
  const isNigelEnabled = useExperiments()['web-disco-rm-nigel']?.value === 'on';
  return <MembershipIncludes label={<FormattedMessage defaultMessage="Peak membership includes" />} rows={rows(isNigelEnabled, isInUs)} />;
}
